import { useMq } from "../common/mediaquery";

export function headerScripts() {
  class Header {
    target: HTMLElement;
    body: HTMLElement;
    dropDownTriggers: NodeListOf<Element>;
    globalMenu: HTMLElement;
    footerAccordionTrigger: NodeListOf<Element>;
    langButton: HTMLElement;
    langList: NodeListOf<Element>;

    constructor() {
      this.body = document.querySelector('body');
      this.target = document.querySelector('.js-header');
      if(!this.target) return;
      this.globalMenu = this.target.querySelector('.js-global-nav');
      this.dropDownTriggers = this.target.querySelectorAll('.js-dropdown');
      this.langList = this.target.querySelectorAll('.o-header_lang-list-button');
      this.langButton = this.target.querySelector('.js-lang-button');
      this.footerAccordionTrigger = document.querySelectorAll('.js-footer-accordion');
      this.init();
    }

    init() {
      this.intersectionHeaderLine(this.target);
      this.humburgerMenu();
      this.dropDownMenu();
      this.currentMenu();
      this.footerAccordion();
      this.langMenu();
    }

    intersectionHeaderLine(target: HTMLElement) {
      if(!target) return;
      const targetLine = document.querySelector('.o-header_line');

      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0
      };

      const callback = (entries: IntersectionObserverEntry[]) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.body.classList.remove('is-scrolled');
          } else {
            this.body.classList.add('is-scrolled');
          }
        });
      };

      const observer = new IntersectionObserver(callback, options);

      observer.observe(targetLine);
    }

    dropDownMenu() {
      this.dropDownTriggers.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => {
          const target = trigger.querySelector('.o-global-menu_trigger');
          const panel = trigger.querySelector('.o-global-menu_panel');

          target.classList.add('is-active');
          panel.classList.add('is-active');
        });
        
        trigger.addEventListener('mouseleave', () => {
          const target = trigger.querySelector('.o-global-menu_trigger');
          const panel = trigger.querySelector('.o-global-menu_panel');

          target.classList.remove('is-active');
          panel.classList.remove('is-active');
        });
      });
    }

    humburgerMenu() {
      const menuTriggers = this.target.querySelectorAll('.js-menu-trigger');
      let menuFlag = false;

      menuTriggers.forEach((menuTrigger) => {
        menuTrigger.addEventListener('click', () => {
          useMq({
            type: 'max',
            query: '749px',
            onMatch: () => {
              if (menuFlag) {
                this.body.classList.remove('is-hamburger-sp-open');
                menuFlag = false;
              } else {
                this.body.classList.add('is-hamburger-sp-open');
                menuFlag = true;
              }
            },
            onUnmatch: () => {
              if (menuFlag) {
                this.body.classList.remove('is-hamburger-pc-open');
                menuFlag = false;
              } else {
                this.body.classList.add('is-hamburger-pc-open');
                menuFlag = true;
              }
            }
          })
        });
      });


      useMq({
        type: 'max',
        query: '749px',
        onMatch: () => {
          if (this.body.classList.contains('is-hamburger-pc-open')) {
            menuFlag = true;
            this.body.classList.remove('is-hamburger-pc-open');
            this.body.classList.add('is-hamburger-sp-open');
          }
        },
        onUnmatch: () => {
          if (this.body.classList.contains('is-hamburger-sp-open')) {
            menuFlag = true;
            this.body.classList.remove('is-hamburger-sp-open');
            this.body.classList.add('is-hamburger-pc-open');
          }
        }
      })
    }

    currentMenu() {
      const path = location.pathname.split('/')[1];
      const menuList = this.globalMenu.querySelectorAll('a');
      if (path === '') return;
      menuList.forEach((menu) => {
        if (menu.getAttribute('href').indexOf(path) !== -1) {
          menu.classList.add('is-current');
        }
      });
    }

    langMenu() {
      const subdomain = location.hostname.split('.')[0];
      if( this.langButton ){
        const langButtonInner = this.langButton.querySelector('span');

        this.langList.forEach((lang) => {
          lang.addEventListener('click', (e) => {
            e.preventDefault();
            const langCode = lang.getAttribute('data-lang');
            langButtonInner.textContent = langCode;
            this.langButton.classList.remove('is-active');
            this.langButton.nextElementSibling.classList.remove('is-active');
          });
        });
  
        this.langButton.addEventListener('click', () => {
          this.langButton.classList.toggle('is-active');
          this.langButton.nextElementSibling.classList.toggle('is-active');
        });
  
        document.addEventListener('click', (e) => {
          if (!this.langButton.contains(e.target as Node)) {
            this.langButton.classList.remove('is-active');
            this.langButton.nextElementSibling.classList.remove('is-active');
          }
        });
      }

    }

    footerAccordion() {
      this.footerAccordionTrigger.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const target = trigger.nextElementSibling;
          if (target.classList.contains('is-opened')) {
            trigger.classList.remove('is-opened');
            target.classList.remove('is-opened');
          } else {
            trigger.classList.add('is-opened');
            target.classList.add('is-opened');
          }
        });
      })
    }
  }

  new Header();
}